import React from "react";
import PropTypes from "prop-types";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faDollarSign, faStar } from "@fortawesome/fontawesome-free-solid";
import { Link } from "react-router-dom";
import FileSaver from 'file-saver';
import Constanta from "../../config/constanta";
import {imgSrcToBlob} from 'blob-util'
import {config} from '../../config/config';
import axios from 'axios';
import "./card.css";

let getId = (event, applicant) => {
  if(applicant.idFile !== "") {
    const uri = config.resourceIPHost + "uploads/id/" + applicant.idFile;
    imgSrcToBlob(uri, 'image/png', 'Anonymous').then((blob) =>{
      const name = applicant.firstName.split(" ").join("_") + "_" + applicant.lastName.split(" ").join("_");
      if(blob instanceof(Blob)){
        FileSaver.saveAs(blob, `ID-${name}-${applicant.id}.png`);
      } else {
        alert('The file is corrupt and cannot be downloaded.');
      }
    }).catch((err) =>{
      console.error(err);
      alert('The file is corrupt and cannot be downloaded.');
    });
  }
};

let getCV = (event, applicant) => {
  if(applicant.cvFile !== "") {
    const filenameArr = applicant.cvFile.split('.');
    const uri = config.resourceIPHost + "uploads/resume/" + applicant.cvFile;
    axios.get(uri, {responseType: "blob"}).then(resp => {
      const name = applicant.firstName.split(" ").join("_") + "_" + applicant.lastName.split(" ").join("_");
      if(resp.data instanceof(Blob)) {
        FileSaver.saveAs(resp.data, `CV-${name}-${applicant.id}.${filenameArr[filenameArr.length - 1]}`);
      } else {
        alert('The file is corrupt and cannot be downloaded.');
      }
    }).catch((err) =>{
      console.error(err);
      alert('The file is corrupt and cannot be downloaded.');
    });
  }
};

const card = props => {
  return (
    <div className="card-applicant-container">
      <div className="card-applicant-header clearfix">
        {/* <div className="card-applicant-header-left">
          <img style={{ backgroundImage: `url("${props.profilePicture}")` }} src={props.profilePicture} alt="applicant profile" />
        </div> */}
        {/* <div className="card-applicant-header-right"> */}
        <div>
          <h1>{props.title}</h1>
          <p>{props.teaser}</p>
        </div>
      </div>
      <div className="card-applicant-body">{props.children}</div>
      <div className="card-applicant-footer">
        <hr />
        <p className="expected-salary">
          <FontAwesomeIcon icon={faDollarSign} />&nbsp;
          <strong>{props.expectedSalary}</strong>&nbsp;
          <span className="badge badge-primary">Expected Salary</span>
        </p>
        <hr />
        {
          props.applicant.referralOther.trim() !== "" &&
          <div>
            <p>
              <FontAwesomeIcon icon={faStar} style={{color: "gold"}} />&nbsp;
              <strong>{props.applicant.referralOther}</strong>{" "}<span className="badge badge-success">Refference{
                " " +
                Constanta.referralOption.find(
                  x => x.referral === props.applicant.referral
                ).name }</span>
            </p>
            <hr />
          </div>
        }
        <p>
          {props.skill.split(",").map((result, index) => { 
              return  result.trim() !== ""? (
                <React.Fragment key={index}>
                  <span className="badge badge-info" style={{whiteSpace: "pre-wrap"}}>{result.trim()}</span>
                  &nbsp;{" "}
                </React.Fragment>
              ) : "";
          })}
        </p>
      </div>
      <div className="card-applicant-action">
        <hr />
        <Link
          to={{
            pathname: "/aoc/applicant/" + props.id + "/detail",
            applicant: props.applicant
          }}
          className="btn btn-link"
        >
          <strong>View detail</strong>
        </Link>
        {
          props.applicant.idFile !=="" &&
          <button className="btn btn-link" onClick={(e) => getId(e, props.applicant)}><strong>Download ID File</strong></button>
        }
        {
          props.applicant.cvFile !=="" &&
          <button className="btn btn-link" onClick={(e) => getCV(e, props.applicant)}><strong>Download CV</strong></button>
        }
      </div>
      <div
        className="card-applicant-support"
        style={{ backgroundColor: props.statusColor }}
      >
        <p>{props.status}</p>
      </div>
    </div>
  );
};

card.propTypes = {
  profilePicture: PropTypes.string,
  title: PropTypes.string,
  teaser: PropTypes.string,
  children: PropTypes.any,
  skill: PropTypes.string,
  expectedSalary: PropTypes.string,
  status: PropTypes.string
};

export default card;



// WEBPACK FOOTER //
// ./src/components/Card/card.js